import api from '../connectors/Api'

const API = api()

export default {
  namespaced: true,
  state: {
    items: []
  },
  mutations: {
    setItems (state, list) {
      state.items = list
    }
  },
  getters: {
    getByTag: (state, getters, rootState) => (tag) => {
      const lang = rootState.lang
      const archetype = state.items.find(element => element.tag === tag)

      if (archetype) {
        return {
          id: archetype.id,
          tag: tag,
          name: archetype.translations[lang].name,
          subname: archetype.translations[lang].subname
        }
      } else {
        return false
      }
    },
    getName: (state, getters, rootState) => (id) => {
      const lang = rootState.lang
      const item = state.items.find((item) => item.id === id)
      if (!item) {
        return ''
      }
      return item && item.translations[lang] ? item.translations[lang].name : item.name
    }
  },
  actions: {
    get ({ commit, state, dispatch }) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.getArchetypes(token)
            .then((res) => {
              commit('setItems', res.body.list)
              resolve(state.items)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    }
  }
}
